// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { CollateralAgreement_SettlementObligation } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral/module';

export const useFulfilSettlementObligation = () => {
  const { submit } = useExerciseSubmission(
    CollateralAgreement_SettlementObligation.SettlementObligation_Fulfil,
    'Successfully fulfilled settlement obligation',
    'Failed to fulfill settlement obligation',
  );
  return submit;
};
